import AzureUrlBuilder from "~/fc/utils/azure";

export default function ({  query, redirect, app }) {
  const locale = app.$cookies.get("locale") || "en";
  const azureUrlBuilder = new AzureUrlBuilder(locale);
  if (query.selected === "local_sign_up") {
    redirect(azureUrlBuilder.SIGNUP_FLOW_URL);
  }
}
